// Cart Accessibility - Focus Management & Screen Reader Announcements

class CartAccessibility {
  constructor() {
    this.cartDrawer = document.querySelector('[cart-open="true"]') || 
                      document.querySelector('.upez--inner-drawer-container');
    this.addToCartBtn = document.querySelector('button[toggle-element="cart-drawer"]');
    this.liveRegion = this.createLiveRegion();
    this.isCartOpen = false;
    
    console.log('🛒 CartAccessibility initialized');
    console.log('Cart drawer found:', !!this.cartDrawer, this.cartDrawer);
    console.log('Add to cart button found:', !!this.addToCartBtn, this.addToCartBtn);
    
    this.init();
  }

  // Create an ARIA live region for announcements
  createLiveRegion() {
    const region = document.createElement('div');
    region.setAttribute('aria-live', 'polite');
    region.setAttribute('aria-atomic', 'true');
    region.className = 'sr-only'; // Visually hidden but accessible to screen readers
    region.style.position = 'absolute';
    region.style.left = '-10000px';
    region.style.width = '1px';
    region.style.height = '1px';
    region.style.overflow = 'hidden';
    document.body.appendChild(region);
    return region;
  }

  // Announce message to screen readers
  announce(message) {
    this.liveRegion.textContent = '';
    // Force reflow to ensure announcement is read
    void this.liveRegion.offsetHeight;
    this.liveRegion.textContent = message;
  }

  // Check if cart is currently open
  isCartCurrentlyOpen() {
    if (!this.cartDrawer) return false;
    
    const cartOpen = this.cartDrawer.getAttribute('cart-open');
    const opacity = window.getComputedStyle(this.cartDrawer).opacity;
    const pointerEvents = window.getComputedStyle(this.cartDrawer).pointerEvents;
    
    console.log('🔍 Cart state check:', { cartOpen, opacity, pointerEvents });
    
    return cartOpen === 'true' && opacity === '1' && pointerEvents !== 'none';
  }

  // Get the first focusable element in the cart
  getFirstFocusableElement() {
    const focusableSelectors = [
      'button:not(:disabled)',
      'a[href]',
      'input:not(:disabled)',
      '[tabindex]:not([tabindex="-1"])'
    ].join(', ');
    
    const focusableElements = this.cartDrawer?.querySelectorAll(focusableSelectors);
    return focusableElements?.[0];
  }

  // Move focus to cart and announce
  focusCart() {
    if (!this.cartDrawer) return;

    console.log('⏱️ Moving focus to cart...');
    
    // Move focus to the first focusable element in cart
    const firstFocusable = this.getFirstFocusableElement();
    console.log('First focusable element:', firstFocusable);
    
    if (firstFocusable) {
      firstFocusable.focus();
      console.log('✅ Focus moved to:', firstFocusable.tagName, firstFocusable.className);
    } else {
      // Fallback: focus the cart container itself
      this.cartDrawer.setAttribute('tabindex', '-1');
      this.cartDrawer.focus();
      console.log('✅ Focus moved to cart container (fallback)');
    }

    // Announce to screen readers
    this.announce('Shopping cart opened. Your items are listed below.');
    this.isCartOpen = true;
  }

  // Setup event listeners
  init() {
    if (!this.addToCartBtn || !this.cartDrawer) {
      console.warn('Cart accessibility: Required elements not found');
      return;
    }

    // Listen for form submission
    const form = this.addToCartBtn.closest('form');
    if (form) {
      form.addEventListener('submit', (e) => {
        // Small delay to allow DOM to update
        setTimeout(() => {
          if (this.isCartCurrentlyOpen()) {
            this.focusCart();
          }
        }, 300);
      });
    }

    // Alternative: Listen for cart-drawer attribute changes
    this.observeCartState();

    // Handle close button - return focus to add to cart button
    this.setupCloseButtonHandler();
  }

  // Observe cart state changes using MutationObserver
  observeCartState() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'cart-open') {
          const isOpen = this.cartDrawer.getAttribute('cart-open') === 'true';
          
          if (isOpen && !this.isCartOpen) {
            setTimeout(() => {
              this.focusCart();
            }, 300);
          } else if (!isOpen && this.isCartOpen) {
            this.isCartOpen = false;
            this.announce('Shopping cart closed.');
            // Return focus to the add to cart button
            this.addToCartBtn?.focus();
          }
        }
      });
    });

    observer.observe(this.cartDrawer, {
      attributes: true,
      attributeFilter: ['cart-open']
    });
  }

  // Handle close button click
  setupCloseButtonHandler() {
    const closeBtn = this.cartDrawer?.querySelector('.upez--close-button');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        setTimeout(() => {
          this.announce('Shopping cart closed.');
          this.addToCartBtn?.focus();
        }, 100);
      });
    }
  }
}

// Initialize when DOM is ready
console.log('📄 Document ready state:', document.readyState);

function initCartAccessibility() {
  console.log('🚀 Initializing CartAccessibility...');
  
  // Check if required elements exist
  const cartDrawer = document.querySelector('[cart-open="true"]') || 
                     document.querySelector('.upez--inner-drawer-container');
  const addToCartBtn = document.querySelector('button[toggle-element="cart-drawer"]');
  
  if (!cartDrawer || !addToCartBtn) {
    console.warn('⚠️ Elements not found yet, retrying in 500ms...');
    setTimeout(initCartAccessibility, 500);
    return;
  }
  
  console.log('✅ All elements found, initializing CartAccessibility');
  new CartAccessibility();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCartAccessibility);
} else {
  // DOM already loaded
  setTimeout(initCartAccessibility, 100);
}